// extracted by mini-css-extract-plugin
export var placeholderContainer = "map-module--placeholderContainer--f067d";
export var placeholderText = "map-module--placeholderText--960a2";